function formatTextSizeWeight(size, weight) {
  return {
    fontSize: size, 
    fontWeight: weight.toString()
  }
}

export { formatTextSizeWeight }